export const INTAKE_SOURCES = [
  ["careers", "Careers page"], ["manual_upload", "Manual upload"], ["bulk_import", "Bulk import"],
  ["upload", "Job resume upload"], ["seed", "Demo seed"], ["manual", "Manual"],
];

export const ROW_STATUS = { queued: "Queued", processing: "Processing", new: "New", duplicate: "Duplicate", failed: "Failed" };

export const EMPTY_REVIEW = {
  name: "", email: "", phone: "", location: "", current_title: "", current_company: "", years_experience: null,
  skills: [], education: [], experience: [], links: [], summary: "",
};

export const toReview = (d = {}) => Object.fromEntries(Object.keys(EMPTY_REVIEW).map((k) => [k, d[k] ?? EMPTY_REVIEW[k]]));

export const downloadBlob = (data, filename) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = filename;
  a.click();
};
